module.exports = __webpack_public_path__ + "img/guide-suunto-2.78daada3.gif";